import brandJson from "../../../brand/brand.json";

/**
 * Typed, frozen view of `brand/brand.json` — the single source of truth for
 * Ashtra's name, domain, support email, logo, and brand colours, shared by
 * both the frontend and backend.
 *
 * This is the ONLY place the app should learn its own name/domain/colours.
 * Do not hardcode "Ashtra", "ashtra.ai", a support email, or a brand hex
 * value anywhere else — import from here instead (see
 * `src/test/consistency/brand/brand-source.test.ts`, which enforces this).
 */

export interface BrandColorScale {
  readonly 50: string;
  readonly 100: string;
  readonly 200: string;
  readonly 300: string;
  readonly 400: string;
  readonly 500: string;
  readonly 600: string;
  readonly 700: string;
  readonly 800: string;
  readonly 900: string;
}

export interface Brand {
  readonly name: string;
  readonly legalName: string;
  readonly productName: string;
  readonly tagline: string;
  readonly domain: string;
  readonly url: string;
  readonly supportEmail: string;
  readonly logo: {
    readonly primary: string;
    readonly aspectRatio: number;
  };
  readonly color: {
    readonly brand: {
      readonly blue: string;
      readonly blueText: string;
      readonly gold: string;
      readonly goldText: string;
      readonly grey: string;
    };
    readonly scale: {
      readonly blue: BrandColorScale;
      readonly gold: BrandColorScale;
      readonly grey: BrandColorScale;
    };
  };
}

export const brand: Brand = Object.freeze(brandJson) as Brand;
